

// Autogenerated 2023-05-18 09:36:21.472129
// gen_js_enum.py proto/proto/queue.proto src/lib/proto/queue_proto.js

const QueueType = {
  QUEUE_TYPE_UNDEFINED: { value: 0, id: "QUEUE_TYPE_UNDEFINED" },
  NewAccount: { value: 1, id: "NewAccount", label: "New Account" },
  Payment: { value: 2, id: "Payment", label: "Payment" },
  NewTDAAccount: { value: 6, id: "NewTDAAccount", label: "New TDA Account" },
  NewRepoSymbol: { value: 7, id: "NewRepoSymbol", label: "New Repo symbol" },
  Rebalance: { value: 8, id: "Rebalance2", label: "Rebalance Request" },
  EmailNotification: { value: 9, id: "EmailNotification", label: "Email Notification" },
  SecurityPurchase: { value: 10, id: "SecurityPurchase", label: "Security Purchase" },
  UGMAinvite: { value: 11, id: "UGMAinvite", label: "UGMA Invite" },
};
const QueuePartition = {
  QUEUE_PARTITION_UNDEFINED: { value: 0, id: "QUEUE_PARTITION_UNDEFINED" },
  QUEUE_PARTITION_OPEN: { value: 1, id: "QUEUE_PARTITION_OPEN", label: "OPEN" },
  QUEUE_PARTITION_CLOSED: { value: 2, id: "QUEUE_PARTITION_CLOSED", label: "CLOSED" },
  QUEUE_PARTITION_CANCELED: { value: 3, id: "QUEUE_PARTITION_CANCELED", label: "CANCELED" },
  QUEUE_PARTITION_FAILED: { value: 4, id: "QUEUE_PARTITION_FAILED", label: "FAILED" },
};
const EmailNotificationScope = {
  EMAIL_NOTIFICATION_TYPE_UNDEFINED: { value: 0, id: "EMAIL_NOTIFICATION_TYPE_UNDEFINED" },
  USER_SCOPE: { value: 1, id: "USER_SCOPE" },
  ACCOUNT_SCOPE: { value: 2, id: "ACCOUNT_SCOPE" },
};
const EmailNotificationOp = {
  EMAIL_NOTIFICATION_OP_UNDEFINED: { value: 0, id: "EMAIL_NOTIFICATION_OP_UNDEFINED" },
  ENQUEUE_NOTIFICATION: { value: 1, id: "ENQUEUE_NOTIFICATION" },
  SEND_EMAIL: { value: 2, id: "SEND_EMAIL" },
};
const EmailNotificationId = {
  EMAIL_NOTIFICATION_ID_UNDEFINED: { value: 0, id: "EMAIL_NOTIFICATION_ID_UNDEFINED" },
  REGULATORY_COMM_YEARLY: { value: 1, id: "REGULATORY_COMM_YEARLY" },
  REGULATORY_COMM_QUARTERLY: { value: 2, id: "REGULATORY_COMM_QUARTERLY" },
};
export { QueueType,QueuePartition,EmailNotificationScope,EmailNotificationOp,EmailNotificationId };
